enum Layout {
  default = 'default',
  panel = 'panel'
}
export default Layout;
